import React from 'react';
import Text from '../../../components_new/common/Text';
import Line from '../../../components_new/common/Line';
import styled from 'styled-components';
import styledProps from 'styled-props/lib/styledProps';
import { Flex, Box, Absolute } from 'rebass';
import { colors } from '../../../tailwind';
import FontAwesome from 'react-icons/fa';

const bigLittleBreakpoint = '1200px';

const imgDefinitions = {
  small: {
    width: '36px',
    height: '36px',
    margin: '4px',
  },
  large: {
    width: '100%',
    margin: '12px 12px 12px 8px',
  },
};

const imgWidths = {
  small: imgDefinitions.small.width,
  large: imgDefinitions.large.width,
};

const imgHeights = {
  small: imgDefinitions.small.height,
  large: imgDefinitions.large.height,
};

const imgMargins = {
  small: imgDefinitions.small.margin,
  large: imgDefinitions.large.margin,
};

const ThumbsContainer = styled(Flex)`
  display: flex;
  flex-wrap: wrap;
`;

const ImgContainer = styled.div`
  height: 36px;
  width: 36px;
  margin-top: 8px;
  cursor: pointer;
  margin-right: 8px;
  position: relative;

  @media screen and (min-width: ${bigLittleBreakpoint}) {
    height: 86px;
    width: 86px;
  }
`;

const Img = styled.img`
  object-fit: cover;
  height: 36px;
  width: 36px;

  @media screen and (min-width: ${bigLittleBreakpoint}) {
    height: 86px;
    width: 86px;
  }
`;

const ImgOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(216, 216, 216, 0.7);
`;

const Li = styled.li`
  white-space: normal;
`;

const Ul = styled.ul`
  padding-left: 17px;
`;

const Description = styled(Text)`
  white-space: pre-wrap;
`;

const FocusedImgContainer = styled.div`
  max-height: 314px;
  display: flex;
  justify-content: center;
  position: relative;
  min-width: 550px;
  @media screen and (min-width: ${bigLittleBreakpoint}) {
    min-width: 450px;
    max-height: 362px;
  }
`;

const FocusedImg = styled.img`
  object-fit: contain;
  height: 100%;
  max-height: 314px;
  width: auto;
  flex-shrink: 1;
  margin-left: 8px;
  margin-right: 8px;

  @media screen and (min-width: ${bigLittleBreakpoint}) {
    max-height: 362px;
  }
`;

const PlaceholderImg = styled.div`
  display: inline-block;
  max-height: 314px;
  background-color: ${colors.offWhite};
  flex-grow: 1;

  @media screen and (min-width: ${bigLittleBreakpoint}) {
    max-height: 362px;
  }
`;

const SlideButton = styled.div`
  height: 36px;
  width: 24px;
  border-top-left-radius: ${p => (p.right ? '18px' : 0)};
  border-bottom-left-radius: ${p => (p.right ? '18px' : 0)};
  border-top-right-radius: ${p => (p.left ? '18px' : 0)};
  border-bottom-right-radius: ${p => (p.left ? '18px' : 0)};
  padding-left: 6px;
  padding-right: 6px;
  display: flex;
  background-color: ${colors.coolGrayLight};
  justify-content: ${p => (p.left ? 'flex-start' : 'flex-end')};
  align-items: center;
  cursor: pointer;
  color: ${colors.white};
`;

export default props => {
  const thumbs = props.images.map((e, i) => (
    <ImgContainer small onClick={() => props.updateMainImg(e, i)} key={i}>
      <Img src={e} />
      {i !== props.focusedIndex && <ImgOverlay />}
    </ImgContainer>
  ));

  const rentalConditions = props.rentalConditions
    ? props.rentalConditions.map((e, i) => <Li key={i}>{e.description}</Li>)
    : [];

  const focusedImage = props.focusedImage
    .replace('x_large_', 'x_medium_')
    .replace('x_small_', 'x_medium_')
    .replace('small_', 'x_medium_');

  return (
    <Box p="24px">
      <div className="f f-columns f-between-start">
        <div className="">
          <Text bannersmall primaryDark bold noclip lineSpacing="36px">
            {props.title}
          </Text>
          <div className="f-columns f-start-center mb-m">
            <img
              src="/icons/map-marker-alt-solid.svg"
              width="10px"
              height="14px"
            />
            <Text headerdetails inline ml={2}>
              {props.location || 'Utah'}
            </Text>
          </div>
        </div>
        <div>
          <i className="fal fa-flag pointer" onClick={props.onReport} />
        </div>
      </div>
      <DescriptionMasterBox preview={props.preview}>
        <Box flex={1}>
          <Flex flexDirection="column">
            <FocusedImgContainer large>
              <PlaceholderImg />
              <FocusedImg src={focusedImage} />
              <PlaceholderImg />
              {props.focusedIndex > 0 && (
                <Absolute top="48%" left={0}>
                  <SlideButton
                    left
                    onClick={() => props.updateMainImg(null, null, 'left')}
                  >
                    <i className="fa fa-chevron-left" />
                  </SlideButton>
                </Absolute>
              )}
              {props.focusedIndex < props.images.length - 1 && (
                <Absolute top="48%" right={0}>
                  <SlideButton
                    right
                    onClick={() => props.updateMainImg(null, null, 'right')}
                  >
                    <i className="fa fa-chevron-right" />
                  </SlideButton>
                </Absolute>
              )}
            </FocusedImgContainer>
            <ThumbsContainer mt={4} count={props.images.length}>
              {thumbs}
            </ThumbsContainer>
          </Flex>
        </Box>
        <TextContainer flex={1} preview={props.preview}>
          <Text textheader grayDarkMedium>Description</Text>
          <Description paragraph mt={3} mb={5} noclip>
            {props.description}
          </Description>
          <Line />
          <Text textheader mt={5} grayDarkMedium>
            Rental Rules
          </Text>
          <Text pagagraph mt={3} noclip>
            <Ul>
              {rentalConditions && rentalConditions.length > 0
                ? rentalConditions
                : 'No custom requests'}
            </Ul>
          </Text>
        </TextContainer>
      </DescriptionMasterBox>
    </Box>
  );
};

const DescriptionMasterBox = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: ${bigLittleBreakpoint}) {
    flex-direction: ${p => (p.preview ? 'column' : 'row')};
  }
`;

const TextContainer = styled(Box)`
  margin-top: 32px;
  margin-left: 0px;
  flex-grow: 1;

  @media screen and (min-width: ${bigLittleBreakpoint}) {
    margin-top: ${p => (p.preview ? '32px' : '0px')};
    margin-left: ${p => (p.preview ? '0px' : '32px')};
  }
`;



// WEBPACK FOOTER //
// ./src/routes/presentation/Details/Description.js